"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateFullAddress = exports.generateAddressFieldValue = exports.getAddressFieldEmptyValue = void 0;
const getAddressFieldEmptyValue = () => {
    return {
        location_address: "",
        location_address2: "",
        location_zip: "",
        location_country: "",
        location_state: "",
        location_city: "",
        location_longitude: "",
        location_latitude: "",
        sys_root: "",
    };
};
exports.getAddressFieldEmptyValue = getAddressFieldEmptyValue;
const generateAddressFieldValue = (value) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return {
        location_address: (_a = value.location_address) !== null && _a !== void 0 ? _a : "",
        location_address2: (_b = value.location_address2) !== null && _b !== void 0 ? _b : "",
        location_zip: (_c = value.location_zip) !== null && _c !== void 0 ? _c : "",
        location_country: (_d = value.location_country) !== null && _d !== void 0 ? _d : "",
        location_state: (_e = value.location_state) !== null && _e !== void 0 ? _e : "",
        location_city: (_f = value.location_city) !== null && _f !== void 0 ? _f : "",
        location_longitude: (_g = value.location_longitude) !== null && _g !== void 0 ? _g : "",
        location_latitude: (_h = value.location_latitude) !== null && _h !== void 0 ? _h : "",
        sys_root: (_j = value.sys_root) !== null && _j !== void 0 ? _j : "",
    };
};
exports.generateAddressFieldValue = generateAddressFieldValue;
const generateFullAddress = (value) => {
    const nestedSlugs = [
        "address",
        "address2",
        "city",
        "state",
        "zip",
        "country",
    ];
    let result = "";
    for (let i = 0; i < nestedSlugs.length; i++) {
        const part = value[nestedSlugs[i]];
        if (!part)
            continue;
        if (result)
            result += ", ";
        result += part;
    }
    return result;
};
exports.generateFullAddress = generateFullAddress;
